import ActionTypes from '../constants';

const initialState = {
    Lpos: {},
    Lpo: {},
    LpoId: {}
    // loading: false,
};

const LpoReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETLPOSUCCESS:
            return {
                ...state,
                Lpos: action.payload,
            }
        case ActionTypes.GETLPOBYIDSUCCESS:
            return {
                ...state,
                Lpo: action.payload,
            }
        case ActionTypes.SAVELPOSUCCESS:
            return {
                ...state,
                LpoId: action.payload,
            }
        default:
            return state;
    }
}

export default LpoReducer;